// Formulaire « Soumettre votre photo » — galerie participative
// Élément : elements/elements_v2025/form-submit-photo.njk
// Styles  : v2025/src/css/components/form.css (.form-submit-photo)
//
// Les libellés visibles viennent des data-attributs du <form> (traduits par _()
// côté Nunjucks) : aucun texte en dur ici.

const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/heic", "image/heif"];
const ALLOWED_EXTENSIONS = /\.(jpe?g|png|heic|heif)$/i;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " KB";
  return (bytes / 1024 / 1024).toFixed(1) + " MB";
}

function fieldWrapper(el) {
  return el.closest(".form-field") || el.closest("fieldset");
}

function labelTextFor(el, scope) {
  const wrapper = scope || fieldWrapper(el);
  const label = wrapper && (wrapper.querySelector(".form-label") || wrapper.querySelector("legend") || wrapper.querySelector("label[for='" + el.id + "']"));
  return label ? label.textContent.replace(/\s+/g, " ").trim().replace(/\s*\*$/, "") : (el.name || "");
}

function initSubmitPhotoForm(form) {
  const fileInput = form.querySelector(".js-file-input");
  const dropZone = form.querySelector(".js-dropzone");
  const previewList = form.querySelector(".js-preview-list");
  const previewHint = form.querySelector(".js-preview-hint");
  const metaPool = form.querySelector(".js-photo-meta-pool");
  // Un jeu « titre + légende » par photo autorisée. On DÉPLACE ces blocs dans les
  // lignes d'aperçu au lieu de les recréer : les valeurs saisies survivent aux
  // re-rendus (ajout / suppression d'une photo).
  const metaBlocks = Array.from(form.querySelectorAll(".js-photo-meta"));
  const summary = form.querySelector(".js-form-error-summary");
  const summaryList = form.querySelector(".js-form-error-list");

  const maxFiles = parseInt(form.dataset.maxFiles, 10) || 5;
  const maxSize = (parseInt(form.dataset.maxSize, 10) || 25) * 1024 * 1024;

  // Source de vérité des fichiers : on la resynchronise dans l'input via
  // DataTransfer pour que le POST natif envoie bien la sélection courante.
  let files = [];
  let previewUrls = [];

  // Le message d'erreur de la zone photos est réutilisé pour afficher les refus
  // de fichiers : on garde le libellé d'origine pour pouvoir le restaurer.
  const photoErrorEl = fieldWrapper(fileInput).querySelector(".form-error");
  const photoErrorDefault = photoErrorEl.textContent;

  /* ---------------------------------------------------------- Upload */

  function syncFileInput() {
    const transfer = new DataTransfer();
    files.forEach((file) => transfer.items.add(file));
    fileInput.files = transfer.files;
  }

  function metaFieldsOf(block) {
    return Array.from(block.querySelectorAll(".js-photo-meta-field"));
  }

  // La photo retirée emporte son titre et sa légende : on remonte d'un cran les
  // métadonnées des photos suivantes, la dernière repart vide.
  function shiftMetaValues(removedIndex) {
    for (let i = removedIndex; i < metaBlocks.length - 1; i += 1) {
      const next = metaFieldsOf(metaBlocks[i + 1]);
      metaFieldsOf(metaBlocks[i]).forEach((field, position) => {
        field.value = next[position].value;
      });
    }
    metaFieldsOf(metaBlocks[metaBlocks.length - 1]).forEach((field) => {
      field.value = "";
    });
    // Réaligne les compteurs de caractères sur les nouvelles valeurs
    metaBlocks.forEach((block) => {
      metaFieldsOf(block).forEach((field) => field.dispatchEvent(new Event("input")));
    });
  }

  function renderPreviews() {
    previewUrls.forEach((url) => URL.revokeObjectURL(url));
    previewUrls = [];

    // Remiser les blocs AVANT de vider la liste, sinon innerHTML les détruit
    metaBlocks.forEach((block) => metaPool.appendChild(block));
    previewList.innerHTML = "";

    files.forEach((file, index) => {
      const url = URL.createObjectURL(file);
      previewUrls.push(url);

      const item = document.createElement("li");
      item.className = "preview-item";
      item.innerHTML =
        '<img alt="" src="' +
        url +
        '">' +
        '<div class="preview-body">' +
        '<div class="preview-meta"><span class="preview-name"></span> <span class="preview-size"></span></div>' +
        '<div class="preview-fields"></div>' +
        "</div>" +
        '<button type="button" class="preview-remove"><i class="fa-light fa-xmark" aria-hidden="true"></i><span class="sr-only"></span></button>';

      item.querySelector(".preview-name").textContent = file.name;
      item.querySelector(".preview-size").textContent = formatFileSize(file.size);
      item.querySelector(".preview-remove .sr-only").textContent = (form.dataset.msgRemove || "Remove") + " : " + file.name;

      item.querySelector(".preview-remove").addEventListener("click", () => {
        files.splice(index, 1);
        shiftMetaValues(index);
        syncFileInput();
        renderPreviews();
        fileInput.focus();
      });

      if (metaBlocks[index]) {
        item.querySelector(".preview-fields").appendChild(metaBlocks[index]);
      }

      previewList.appendChild(item);
    });

    if (previewHint) previewHint.classList.toggle("hidden", files.length === 0);
  }

  function isAllowed(file) {
    return ALLOWED_TYPES.includes(file.type) || ALLOWED_EXTENSIONS.test(file.name);
  }

  function addFiles(fileList) {
    const errors = [];

    Array.from(fileList).forEach((file) => {
      if (files.length >= maxFiles) {
        const message = (form.dataset.msgMaxfiles || "").replace("{max}", maxFiles);
        if (message && !errors.includes(message)) errors.push(message);
        return;
      }
      if (!isAllowed(file)) {
        errors.push((form.dataset.msgType || "").replace("{file}", file.name));
        return;
      }
      if (file.size > maxSize) {
        errors.push((form.dataset.msgMaxsize || "").replace("{file}", file.name).replace("{max}", maxSize / 1024 / 1024));
        return;
      }
      // Évite les doublons quand on redépose deux fois le même fichier
      const duplicate = files.some((existing) => existing.name === file.name && existing.size === file.size);
      if (!duplicate) files.push(file);
    });

    syncFileInput();
    renderPreviews();

    const wrapper = fieldWrapper(fileInput);
    if (errors.length) {
      photoErrorEl.textContent = errors.join(" ");
      wrapper.classList.add("has-error");
    } else if (files.length) {
      photoErrorEl.textContent = photoErrorDefault;
      wrapper.classList.remove("has-error");
    }
  }

  fileInput.addEventListener("change", () => {
    // On repart de la sélection en cours pour la fusionner avec l'existante
    addFiles(fileInput.files);
  });

  // Clic n'importe où sur la zone : on relaie vers l'input (le <label> intégré
  // gère déjà le cas clavier, on l'exclut pour ne pas ouvrir deux fois le picker)
  dropZone.addEventListener("click", (event) => {
    if (event.target.closest("label")) return;
    fileInput.click();
  });

  let dragCounter = 0;

  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    dropZone.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
  });

  dropZone.addEventListener("dragenter", () => {
    dragCounter += 1;
    dropZone.classList.add("is-dragover");
  });

  dropZone.addEventListener("dragleave", () => {
    dragCounter -= 1;
    if (dragCounter <= 0) {
      dragCounter = 0;
      dropZone.classList.remove("is-dragover");
    }
  });

  dropZone.addEventListener("drop", (event) => {
    dragCounter = 0;
    dropZone.classList.remove("is-dragover");
    if (event.dataTransfer && event.dataTransfer.files.length) {
      addFiles(event.dataTransfer.files);
    }
  });

  /* ------------------------------------------------ Compteurs de caractères */

  form.querySelectorAll(".js-count-input").forEach((input) => {
    const counter = document.getElementById(input.dataset.counter);
    if (!counter) return;
    const max = parseInt(input.getAttribute("maxlength"), 10);

    const update = () => {
      const length = input.value.length;
      counter.textContent = length + " / " + max;
      counter.classList.toggle("is-full", length >= max);
      counter.classList.toggle("is-near", length < max && length >= max * 0.8);
    };

    input.addEventListener("input", update);
    update();
  });

  /* ------------------------------------- Pilules -> champ texte caché (CSV) */

  // Les cases/radios des pilules ne sont pas postées : elles alimentent un
  // champ caché unique dont la valeur est la liste des choix cochés, séparés
  // par une virgule. Elles gardent un `name` (exclusivité + flèches clavier du
  // groupe radio) et sont désactivées juste avant l'envoi.
  const pillValues = Array.from(form.querySelectorAll(".js-pill-value"));

  function sourcesOf(hidden) {
    return Array.from(form.querySelectorAll("." + hidden.dataset.pillSource));
  }

  function syncPillValue(hidden) {
    hidden.value = sourcesOf(hidden)
      .filter((input) => input.checked)
      .map((input) => input.value)
      .join(",");
  }

  pillValues.forEach((hidden) => {
    // Retour d'une validation serveur en échec : on recoche depuis la valeur postée
    if (hidden.value) {
      const restored = hidden.value.split(",").map((value) => value.trim());
      sourcesOf(hidden).forEach((input) => {
        input.checked = restored.includes(input.value);
      });
    }

    sourcesOf(hidden).forEach((input) => {
      input.addEventListener("change", () => syncPillValue(hidden));
    });

    syncPillValue(hidden);
  });

  /* ------------------------------------------------------------ Validation */

  function clearErrors() {
    form.querySelectorAll(".has-error").forEach((el) => el.classList.remove("has-error"));
    form.querySelectorAll("[aria-invalid]").forEach((el) => el.removeAttribute("aria-invalid"));
    summary.classList.add("hidden");
    summaryList.innerHTML = "";
  }

  function flagError(control, wrapper, message) {
    const target = wrapper || fieldWrapper(control);
    target.classList.add("has-error");
    if (control) control.setAttribute("aria-invalid", "true");

    const item = document.createElement("li");
    if (control && control.id) {
      const link = document.createElement("a");
      link.href = "#" + control.id;
      link.textContent = message;
      link.addEventListener("click", (event) => {
        event.preventDefault();
        control.focus();
      });
      item.appendChild(link);
    } else {
      item.textContent = message;
    }
    summaryList.appendChild(item);
  }

  function messageFor(control, wrapper) {
    const scope = wrapper || fieldWrapper(control);
    const errorEl = scope.querySelector(".form-error");
    const label = control ? labelTextFor(control, scope) : "";
    const text = errorEl ? errorEl.textContent.trim() : "";
    return label ? label + " — " + text : text;
  }

  function validate() {
    clearErrors();

    const requireValue = (name) => {
      const control = form.querySelector("[name='" + name + "']");
      if (!control) return;
      if (control.value.trim() === "") {
        flagError(control, null, messageFor(control));
      }
    };

    requireValue("firstname");
    requireValue("lastname");
    requireValue("location");

    const email = form.querySelector("[name='email']");
    if (email && !EMAIL_RE.test(email.value.trim())) {
      flagError(email, null, messageFor(email));
    }

    if (files.length === 0) {
      photoErrorEl.textContent = photoErrorDefault;
      flagError(fileInput, null, messageFor(fileInput));
    }

    const categories = form.querySelectorAll(".js-category");
    if (categories.length && !form.querySelector(".js-category:checked")) {
      const wrapper = categories[0].closest(".form-field");
      flagError(categories[0], wrapper, messageFor(categories[0], wrapper));
    }

    const consents = Array.from(form.querySelectorAll(".js-required-consent"));
    const missingConsent = consents.filter((consent) => !consent.checked);
    if (missingConsent.length) {
      const wrapper = missingConsent[0].closest(".rights-block");
      flagError(missingConsent[0], wrapper, messageFor(missingConsent[0], wrapper));
    }

    // reCAPTCHA : bloque l'envoi tant que le challenge n'est pas résolu.
    // L'erreur rejoint le récapitulatif au lieu de le court-circuiter.
    const recaptchaError = form.querySelector("#errorRecaptcha");
    if (form.querySelector(".g-recaptcha") && typeof window.grecaptcha !== "undefined") {
      if (window.grecaptcha.getResponse().length) {
        if (recaptchaError) recaptchaError.classList.add("hidden");
      } else {
        if (recaptchaError) {
          recaptchaError.classList.remove("hidden");
          const item = document.createElement("li");
          item.textContent = recaptchaError.textContent.trim();
          summaryList.appendChild(item);
        }
      }
    }

    if (summaryList.children.length) {
      summary.classList.remove("hidden");
      summary.focus();
      return false;
    }

    return true;
  }

  form.addEventListener("submit", (event) => {
    if (!validate()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    // Envoi accepté : on neutralise les pilules pour que seuls les champs
    // cachés partent dans le POST (la page navigue, pas besoin de réactiver).
    pillValues.forEach((hidden) => syncPillValue(hidden));
    form.querySelectorAll(".js-pill-input").forEach((input) => {
      input.disabled = true;
    });
    // Idem pour les jeux « titre + légende » restés en réserve (photos non déposées)
    metaBlocks.slice(files.length).forEach((block) => {
      metaFieldsOf(block).forEach((field) => {
        field.disabled = true;
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-form-submit-photo").forEach(initSubmitPhotoForm);
});
